import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";

import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Headline from "../../Headline/Headline";
import SandBoxStatus from "./SandBoxStatus";
import SandBoxLogin from "./SandBoxLogin";
import SandBoxApplications from "./SandBoxApplications";

import * as DeveloperUtils from "../../Utils/DeveloperUtils";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "SANDBOX";

const SandBox = (props) => {
    const intl = useIntl();

    LogService.trace(LOG_TAG, "render");

    let isSandBoxAvailable = DeveloperUtils.isSandBoxAvailable(props.user);

    return (
        <div>
            <Headline
                title={intl.messages.sandBoxTitle}
                subtitle={intl.messages.sandBoxSubTitle}
            />

            <div className="row">
                <div className="col">
                    <div className="card card-body">
                        <div className="card-text">
                            {intl.messages.sandBoxMessage}
                        </div>
                        <div className="card-footer text-left mt-2">
                            <FontAwesomeIcon icon={faArrowRight} className="mr-2 icon-green" />
                            {intl.messages.sandBoxGuideMessage}
                            <Link to="/doc/hub/developer-sandboxed-platform"
                                className="btn-link-green ml-1">Developers Sandbox platform</Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="d-flex col-xs-12 col-sm-12 col-md-6 col-xl-6">
                    <SandBoxStatus />
                </div>

                {isSandBoxAvailable &&
                    <div className="d-flex col-xs-12 col-sm-12 col-md-6 col-xl-6">
                        <SandBoxLogin />
                    </div>
                }
            </div>

            <div className="row">
                <div className="col">
                    <SandBoxApplications />
                </div>
            </div>
        </div>
    );
}

SandBox.propTypes = {
};

const mapStateToProps = state => {
    return {
        user: state.contacts.user
    };
};

export default connect(mapStateToProps)(SandBox);